<div *ngIf="displayData" class="container" style="height: 100%">
  <div style="width: 100%">
    <h2 style="display: inline-block; background-color: grey">
      Report date: {{ dateNow }} -- Trades found: {{ tradesFound }}
    </h2>
    <h2 style="display: inline-block; margin-left: 10%; color: red">
      {{ datefilter }}
    </h2>

    <button
      style="
        border-bottom: 2px solid black;
        margin-bottom: 1%;
        width: 30%;
        float: right;
      "
      (click)="print()"
      class="btn btn-primary btn-block"
    >
      Print
    </button>
  </div>
  <div>
    <h2>Volatillity: {{ volatillity }} -- Underlying: {{ underlying }}</h2>
  </div>

  <div id="tablerecords">
    <table style="border: 2px solid black; margin-bottom: 1%; width: 100%">
      <tr>
        <th>
          <b>Expiration</b>
        </th>
        <th>
          <b>Strike</b>
        </th>
        <th>
          <b>Call Bid/Ask</b>
        </th>
        <th>
          <b>F.M.W</b>
        </th>
        <th>
          <b>Delta</b>
        </th>
        <th>
          <b>Underpricing</b>
        </th>
        <th>
          <b>Underpricing(Ask/Bid)</b>
        </th>
        <th>
          <b>Put Bid/Ask</b>
        </th>
        <th>
          <b>F.M.W</b>
        </th>
        <th>
          <b>Delta</b>
        </th>
        <th>
          <b>Underpricing</b>
        </th>
        <th>
          <b>Underpricing(Ask/Bid)</b>
        </th>
      </tr>
      <ng-container *ngFor="let group of QuoteDataOptions" )>
        <tr>
          <td>{{ formatDate(group.expirationDate) }}</td>
          <td>{{ changeToFixed(group.strikePrice) }}</td>
          <td>
            {{ changeToFixed(group.callBid) }}/{{
              changeToFixed(group.callAsk)
            }}
          </td>
          <td>{{ changeToFixed(group.callFMW) }}</td>
          <td>{{ changeToFixed(group.callDelta) }}</td>
          <td>{{ changeToFixed(group.callUnderPricingPercent) }}</td>
          <td>
            {{ changeToFixed(group.callUnderPricingBid) }}/{{
              changeToFixed(group.callUnderPricingAsk)
            }}
          </td>

          <td>
            {{ changeToFixed(group.putBid) }}/{{ changeToFixed(group.putAsk) }}
          </td>
          <td>{{ changeToFixed(group.putFMW) }}</td>
          <td>{{ changeToFixed(group.putDelta) }}</td>
          <td>{{ changeToFixed(group.putUnderPricingPercent) }}</td>
          <td>
            {{ changeToFixed(group.putUnderPricingBid) }}/{{
              changeToFixed(group.putUnderPricingAsk)
            }}
          </td>
        </tr>
      </ng-container>
    </table>

    <ng-container *ngFor="let group of QuoteData">
      <table
        style="
          border-bottom: 2px solid black;

          margin-bottom: 1%;
          width: 100%;
        "
      >
        <tr>
          <th>
            <b>Side</b>
          </th>
          <th>
            <b>Qty</b>
          </th>
          <th>
            <b>Symbol</b>
          </th>
          <th>
            <b>Expiration</b>
          </th>
          <th>
            <b>Strike</b>
          </th>
          <th>
            <b>Action</b>
          </th>
          <th>
            <b>F.M.W</b>
          </th>
          <th>
            <b>Bid/Ask</b>
          </th>
          <th>
            <b>Prob Profit</b>
          </th>
          <th>
            <b>Break Evens</b>
          </th>
          <th>
            <b>Margin Req.</b>
          </th>
          <th>
            <b>Cost</b>
          </th>
          <th>
            <b>AROR</b>
          </th>
          <th>
            <b>Gain</b>
          </th>
          <th>
            <b>Prob > B/E</b>
          </th>
          <th>
            <b>Prob < B/E</b>
          </th>
        </tr>
        <tr>
          <td>{{ group.side }}</td>
          <td>{{ changeToFixed(group.qty, 0) }}</td>
          <td>{{ group.symbol }}</td>
          <td>{{ formatDate(group.expiration) }}</td>
          <td>{{ changeToFixed(group.strike) }}</td>
          <td>{{ group.type }}</td>
          <td>{{ changeToFixed(group.fmw) }}</td>
          <td>{{ changeToFixed(group.price) }}</td>
          <td>{{ changeToFixed(group.probabilityProfit * 100) }}%</td>
          <td>
            {{ changeToFixed(group.breaksEvenDollarsCostMin) }} -
            {{ changeToFixed(group.breaksEvenDollarsCostMax) }}
          </td>
          <td>{{ changeToFixed(group.marginReq) }}</td>
          <td>{{ changeToFixed(group.cost) }}</td>
          <td>{{ changeToFixed(group.rateOfReturn) }}</td>
          <td>{{ changeToFixed(group.pnl) }}</td>
          <td>{{ changeToFixed(group.probabilityProfit * 100) }}%</td>
          <td>{{ changeToFixed(group.probabilityLoss * 100) }}%</td>
        </tr>
        <tr>
          <td>{{ group.side2 }}</td>
          <td>{{ changeToFixed(group.qty2, 0) }}</td>
          <td>{{ group.symbol }}</td>
          <td>{{ formatDate(group.expiration2) }}</td>
          <td>{{ changeToFixed(group.strike2) }}</td>
          <td>{{ group.type2 }}</td>
          <td>{{ changeToFixed(group.fmw2) }}</td>
          <td>{{ changeToFixed(group.price2) }}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </table>
    </ng-container>
  </div>
</div>
